// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__36kDY","trigger":"style_trigger__aakX9","triggerIcon":"style_triggerIcon__2zACC"};